<template>
  <div class="MyTable">
    <div class="search" v-if="hasFilter">
      <font-awesome-icon :icon="['fas' , 'filter']" />
      <input class="form-controll" type="text" v-model="keyword" placeholder="搜索学校或姓名" />
      <input type="button" value="重置" @click="resetFilter" />
    </div>
    <div class="table fs18">
      <div class="title">
        <div class="item" v-for="t in titles">
          <span>{{t}}</span>
        </div>
      </div>
      <div class="row" v-for="(info, index) in filteredItems" :class="{even: index % 2, gold: heroLength >0 && index < heroLength && isRank, grey: ((typeof info[2]) !=='number' && ((typeof info[3]) !=='number' || info[3] < -2000))&&isRank}">
        <div class="item"  v-for="i in info">{{i}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
 export default {
   name: 'MyTable',
   props: ['titles', 'infos', 'isRank', 'rankLength', 'hasFilter'],
   computed: {
     heroLength () {
       return this.rankLength || (0.05 * this.infos.length).toFixed(0)
     },
     fuse () {
       return new Fuse(this.infos, {
         keys: ['1', '3'],
         threshold: 0.1
       })
     },
     filteredItems () {
       if(this.keyword)
         return this.fuse.search(this.keyword).map(i => i.item)
       else
         return this.infos
     }
   },
   data() {
     return {
       filter: false,
       keyword: '',
     }
   },
   methods: {
     resetFilter () {
        this.keyword = ''
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyTable{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .table{
   /* width: 62.5vw; */
   border: 2px solid #3B4ADD;
   background-color: white;
 }
 .title{
   display: flex;
   background: linear-gradient(90deg, #3b4add, #5e29ed);
   color: white;
   height: 4.0625vw;
 }
 .row{
   display: flex;
   height:3.4375vw;
 }
.search {
  display: flex;
  margin-bottom: 20px;
  font-size: 1.3vw;
   line-height: 1.5vw;
}
.search input[type="text"] {
  font-size: 1.3vw;
   line-height: 1.4vw;
  height: 1.5vw;
   border: none;
   border-bottom: 1px solid #E2E8ED;
   width: 100%;
   box-sizing: border-box;
   padding-left: 0.78vw;
}
 .item{
   display: flex;
   width: 12.5vw;
   align-items: center;
   justify-content: center;
 }
 .even{
   background-color: #f7fbfe;
 }
 .gold {
   background-color: #F7D94C;
   box-shadow: 0 0 5px 4px #F7D94C;
 }
 .even.gold{
   background-color: #FFC408;
   box-shadow: 0 0 5px 4px #FFc408;
 }
 .grey{
   background-color: #eee;
   color: rgba(60,60,60, 0.7);
 }
 .even.grey{
   background-color: #bbb;
   color: rgba(60,60,60, 0.7);
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .title{
     height: 8vw;
     font-size: 12px;
   }
   .row{
     height: 6.8vw;
     width: 90vw;
   }
   .item{
     font-size: 12px;
     width: 22.5vw;
     flex-grow: 1;
     height: 6.8vw;
   white-space: nowrap;
   }
 }
</style>
